var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAntiClockWise(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.74993 6.94163C2.0416 6.88329 2.33327 7.17496 2.3916 7.46663C2.62493 10.0333 4.95826 11.9 7.52493 11.6083C10.0916 11.3166 11.8999 9.09996 11.6666 6.53329C11.4333 3.96663 9.09993 2.09996 6.53326 2.33329C5.30826 2.44996 4.1416 3.09163 3.38326 4.08329H5.24993C5.59993 4.08329 5.83326 4.31663 5.83326 4.66663C5.83326 5.01663 5.59993 5.24996 5.24993 5.24996H2.33327C1.98326 5.24996 1.74993 5.01663 1.74993 4.66663V1.74996C1.74993 1.39996 1.98326 1.16663 2.33327 1.16663C2.68327 1.16663 2.9166 1.39996 2.9166 1.74996V2.85829C5.24993 0.583293 8.92493 0.641626 11.1416 2.97496C13.3583 5.30829 13.3583 8.98329 11.0249 11.2C8.6916 13.4166 5.0166 13.4166 2.79993 11.0833C1.8666 10.15 1.28327 8.92496 1.1666 7.58329C1.1666 7.23329 1.39993 6.99996 1.74993 6.94163C1.6916 6.94163 1.6916 6.94163 1.74993 6.94163Z",
    fill: "#BBBBBB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntiClockWise);
export default __webpack_public_path__ + "static/media/AntiClockWise.d6d95bc7f932d1f64c5c84f881181ea9.svg";
export { ForwardRef as ReactComponent };